"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SankeyMenuConfigurationNodesTags = void 0;
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
/**
   * Tab that handle tag association to nodes, a nodes can have tags from the same grouptag or from different group
   * To visaulize nodes according to their tag associated, the groupTags must be at least have it banner in mode one or mutliple
   * then in the nodes filter button, select the groupTag you want to apply and in the dropdown select the node/nodes you want to see
   *
   * @type {*}
   */
const SankeyMenuConfigurationNodesTags = (t, data, set_data, multi_selected_nodes, tags_group_key, set_tags_group_key) => {
    const tags_visible = Object.keys(data.nodeTags).length > 0;
    if ((tags_group_key == '' && Object.keys(data.nodeTags).length > 0) || (!Object.keys(data.nodeTags).includes(tags_group_key) && Object.keys(data.nodeTags).length > 0)) {
        set_tags_group_key(Object.keys(data.nodeTags)[0]);
    }
    return react_1.default.createElement(react_bootstrap_1.Tab, { eventKey: "tags", title: t('Noeud.tags_node.tags'), disabled: /*node.colorParameter !== 'groupTag'*/ false },
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 4 },
                react_1.default.createElement(react_bootstrap_1.FormLabel, null, t('Tags.GE'))),
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 8 },
                react_1.default.createElement(react_bootstrap_1.Form.Select, { onChange: (evt) => set_tags_group_key(evt.target.value) }, Object.entries(data.nodeTags).filter(nodeTag => nodeTag[1].banner !== 'level').map((tags_group, i) => react_1.default.createElement("option", { key: i, value: tags_group[0], selected: tags_group_key === tags_group[0] }, tags_group[1].group_name))))),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row, style: { paddingTop: '15px' } },
            react_1.default.createElement(react_bootstrap_1.Table, { striped: true, bordered: true, hover: true, responsive: 'sm', size: 'sm', className: 'node_tags_affiliation' },
                react_1.default.createElement("thead", null,
                    react_1.default.createElement("tr", null,
                        react_1.default.createElement("th", null, t('Noeud.Nom')),
                        react_1.default.createElement("th", null, t('Noeud.tags_node.Appartenance')))),
                react_1.default.createElement("tbody", null, tags_visible && tags_group_key != '' && Object.keys(data.nodeTags).includes(tags_group_key) ? Object.entries(data.nodeTags[tags_group_key].tags).map(tags => {
                    const verif = tags[0];
                    let allChecked = true;
                    multi_selected_nodes.current.map((d) => {
                        allChecked = (tags_group_key in d.tags && d.tags[tags_group_key].includes(verif)) ? allChecked : false;
                    });
                    return (react_1.default.createElement("tr", { key: tags[0] },
                        react_1.default.createElement("td", null,
                            react_1.default.createElement(react_bootstrap_1.FormLabel, null, tags[1].name)),
                        react_1.default.createElement("td", null,
                            react_1.default.createElement(react_bootstrap_1.FormCheck, { name: 'element_visible' + tags[0], checked: allChecked, id: tags[0], type: 'checkbox', onChange: (evt) => {
                                    const new_nb_element = evt.target;
                                    const tag_key = new_nb_element.id;
                                    const visible = new_nb_element.checked;
                                    Object.values(data.nodes).filter(f => multi_selected_nodes.current.map(d => d.idNode).includes(f.idNode)).map(d => {
                                        if (visible) {
                                            if (!d.tags[tags_group_key]) {
                                                d.tags[tags_group_key] = [];
                                            }
                                            d.tags[tags_group_key].push(tag_key);
                                        }
                                        else {
                                            d.tags[tags_group_key].splice(d.tags[tags_group_key].indexOf(tag_key));
                                        }
                                    });
                                    set_data(Object.assign({}, data));
                                } }))));
                }) : (react_1.default.createElement(react_1.default.Fragment, null))))));
};
exports.SankeyMenuConfigurationNodesTags = SankeyMenuConfigurationNodesTags;
